























































import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "CurrentOutlined",

  props: {
    items: {
      type: Array,
      default: []
    },

    empty: {
      type: String,
      default: ""
    },

    loading: {
      type: Boolean,
      default: false
    },

    editable: {
      type: Boolean,
      default: false
    },

    draggable: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: "Tags"
    },

    maxHeight: {
      type: String,
      default: "120px"
    }
  },

  setup() {
    return {};
  }
});
